<template>
  <a v-if="link" @click="handleClick">
    <span class="material-icons" :style="{ color: color, fontSize: fontSize }">{{ name }}</span>
  </a>
  <div v-else>
    <span class="material-icons" :style="{ color, fontSize }">{{ name }}</span>
  </div>
</template>

<script>
import uiVariable from '../../config/uiVariable'
export default {
  name: 'K2Icon',
  props: ['name', 'color', 'onclick', 'link', 'fontSize'],
  data() {
    return {
      uiVariable: uiVariable,
    }
  },
  methods: {
    handleClick() {
      this.$emit('onclick')
    },
  },
}
</script>
<style></style>
